import { Component, OnInit } from '@angular/core';
import { QuoteService } from '../../../../../core/services/quote.service';
import { IQuote, IMasterData, IAddQuoteBody, IUpdateQuoteBody, Quote, IQuoteDetailHeaderLbl, IGetKdQuoteDetailBody } from '../../../../../core/models';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { MasterDataService } from '../../../../../core/services/master-data.service';
import { Observable } from 'rxjs';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';

@Component({
  selector: 'app-quote-detail',
  templateUrl: './quote-detail.component.html',
  styleUrls: ['./quote-detail.component.scss']
})
export class QuoteDetailComponent implements OnInit {
  //#region Member Variables & OnInit & Constructor
  quoteHeaderTxt: IQuoteDetailHeaderLbl;

  constructor(private quoteService: QuoteService,
    private masterDataService: MasterDataService,
    private router: Router,
    private route: ActivatedRoute,
    private appNotify: AppNotifyService, private languageTranslationService: LanguageTranslationService) {

  }

  showUpdate: boolean = false;
  isHeaderUpdated: boolean;
  isUpdated: boolean;
  marketSegments: IMasterData[] = [];
  doesHaveError: boolean;
  
  ngOnInit() {
    this.loadLanguageTranslationData();
    if ((!this.quoteHeader)) {
      this.router.navigate(['../'], { relativeTo: this.route });
      return;
    } else {
      if (!this.quoteHeader.quoteCommonId) {
        this.router.navigate(['../'], { relativeTo: this.route });
        return;
      }
      Object.assign(this.quoteService.copyQuoteHeader, this.quoteService.selectedQuoteHeader);

      //this.jobName = this.quoteData.jobName;
      //this.jobNameOld = this.quoteData.jobName;
      //this.jobNumber = this.quoteData.jobNumber + '-' + this.quoteData.revision;
      //this.marketSegmentOld = this.quoteData.marketSegment;
      //this.marketSegment = { name: this.quoteData.marketSegment, value: "", checked: false } as IMasterData;//Need to check data binding
      //this.quoteDate = this.quoteData.quoteDateForDisplay;
      //this.expirationDate = this.quoteData.expirationDateForDisplay;
      //this.leed = this.quoteData.leed;
      //this.leedOld = this.quoteData.leed;

      this.quoteHeader.marketSegmentObj = { name: this.quoteHeader.marketSegment, value: this.quoteHeader.marketSegment, checked: false } as IMasterData;//Need to check data binding;
      this.quoteHeader.jobNumberRevision = this.quoteHeader.jobNumber + '-' + this.quoteHeader.revision;
      Object.assign(this.quoteService.copyQuoteHeader, this.quoteService.selectedQuoteHeader);

      this.isHeaderUpdated = false;
      this.isUpdated = false;

    }
    let excludeMktSegmntItem: boolean = true;
    if (this.quoteHeader.marketSegment === 'Other Buildings') {
      excludeMktSegmntItem = false;
    }
    this.masterDataService.getMarketSegments(excludeMktSegmntItem).then(r => {     
      this.marketSegments = r;
      //console.log(this.marketSegments)
    });

  }
  //#endregion
  protected get quoteHeader(): IQuote {
    return this.quoteService.selectedQuoteHeader;
  }
  protected get copyquoteHeader(): IQuote {
    return this.quoteService.copyQuoteHeader;
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "jobNameLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "quoteTypeLbl" },
      { controlName: "quoteRequestDate" },
      { controlName: "bidDateLbl" },
      { controlName: "leedLbl" },
      { controlName: "indicateTypeLbl" },
      { controlName: "blastLbl" },
    ];
    const componentName = "quoteDetailHeader";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.quoteHeaderTxt = response[response.length - 1];
      //console.log(response);
    }
  }
  //#endregion

  protected quoteHeaders = {
    jobNameLbl: 'Job Name',
    jobNumberLbl: 'Job Number',
    marketSegmentLbl: 'Market Segment',
    quoteDateLbl: 'Quote Date',
    leedLbl: 'LEED',
    expirationDateLbl: 'Expiration Date',
    cancelLbl: 'Cancel',
    updateLbl: 'Update'
  }

  marketSegmentChange(event) {

    this.quoteHeader.marketSegmentObj.name = event.name;
    this.fieldChangeEvent()
  }

  fieldChangeEvent() {

    let isChanged = false;
    this.showUpdate = false;
    if (this.quoteHeader.leed != this.copyquoteHeader.leed) {
      isChanged = true;
    }
    // if (this.quoteHeader.marketSegmentObj.name != this.copyquoteHeader.marketSegmentObj.name) {
    // isChanged = true;
    // }
    if (this.quoteHeader.jobName != this.copyquoteHeader.jobName) {
      isChanged = true;
    }
    if (isChanged == true) {
      this.showUpdate = true;
    } else {
      this.showUpdate = false;
    }
  }
  cancel() {
    //if (this.isHeaderUpdated == false) {
    //  //this.jobName = this.jobNameOld;
    //  //this.leed = this.leedOld;
    //  //this.marketSegment = { name: this.marketSegmentOld, value: "", checked: false } as IMasterData;
    //  this.quoteService.selectedQuoteHeader = this.quoteService.copyQuoteHeader;
    //} else if (this.isUpdated == true) {
    //  //this.jobName = this.jobNameOld;
    //  //this.leed = this.leedOld;
    //  //this.marketSegment = { name: this.marketSegmentOld, value: "", checked: false } as IMasterData;

    //}

    Object.assign(this.quoteService.selectedQuoteHeader, this.quoteService.copyQuoteHeader);

    this.showUpdate = false;
  }


  //Need to test once sql server start running
  updateQuoteHeader() {
    this.quoteHeader.updateInProgress = true;
    const body: IUpdateQuoteBody = {
      jobName: this.quoteHeader.jobName,
      marketSegment: this.quoteHeader.marketSegmentObj ? this.quoteHeader.marketSegmentObj.name : '',
      leed: this.quoteHeader.leed as boolean,
      quoteCommonId: this.quoteHeader.quoteCommonId,
      customerNumber: null,
      marketSegmentId: this.marketSegments.find(m => m.name === this.quoteHeader.marketSegment).value,
      jobNumber: this.quoteHeader.jobNumber
    }
    this.quoteService.updateKdQuoteHeader(body).subscribe((quote: IQuote) => {

      this.isHeaderUpdated = true;
      this.isUpdated = true;

      this.quoteHeader.marketSegment = quote.marketSegment;
      this.quoteHeader.leed = quote.leed;
      this.quoteHeader.jobName = quote.jobName;
      this.quoteHeader.marketSegmentObj = { name: quote.marketSegment, value: "", checked: false } as IMasterData;//Need to check data binding;
      this.quoteHeader.jobNumberRevision = this.quoteHeader.jobNumber + '-' + this.quoteHeader.revision;
      Object.assign(this.quoteService.copyQuoteHeader, this.quoteService.selectedQuoteHeader);

      //this.jobName = response.quoteName;
      //this.jobNameOld = response.quoteName;
      //this.marketSegmentOld = response.marketSegment;
      //this.marketSegment = { name: response.marketSegment, value: "", checked: false } as IMasterData;
      //this.leed = response.leed;
      //this.leedOld = response.leed;
      this.quoteHeader.updateInProgress = false;
      this.showUpdate = false;
      this.appNotify.notify(NotifyType.SUCCESS, "Updated Successfully");
    }, error => {
      this.quoteHeader.updateInProgress = false;
      this.showUpdate = false;
      this.appNotify.notify(NotifyType.ERROR, "Sorry! an Error Occured!. Please refresh the page and try again");
    }
    );
  }


}
